
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    replaceInChain,
    makeHandlerChainAwaitable,
} from "@insite/client-framework/HandlerCreator";

import sendActivationEmail  from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SendActivationEmail";
import { addAccount, AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { SendActivationEmail,chain } from "./UserList/CreateUser";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        userName: string;
        email: string;
        firstName: string;
        lastName: string;
        role: string;
        approver: string;
        sendActivationEmail?:boolean;
    } & HasOnSuccess &
        HasOnError<string>,
    AddAccountApiParameter,
    ServiceResult<AccountModel>
>;


export const SendActivationEmailCustom: HandlerType = async props => {
    const flag = "sendActivationEmail" in props.parameter ? props.parameter.sendActivationEmail : true;
    if (flag) {
        if (props.apiResult.successful) {
            const awaitableSendActivationEmail = makeHandlerChainAwaitable(sendActivationEmail);
            await awaitableSendActivationEmail({ userName: props.apiResult.result.userName })(
                props.dispatch,
                props.getState,
            );
        }
    }
};

replaceInChain(chain, SendActivationEmail, SendActivationEmailCustom);
